// extracted by mini-css-extract-plugin
export default {"Modal":"NewSponsor_Modal__wnkK-","personSearchOverride":"NewSponsor_personSearchOverride__gYqc9"};